import { DayOfWeek } from '@/services/api/petseo.client.wrapper';

export const POLISH_DAY_NAMES: Record<DayOfWeek, string> = {
  [DayOfWeek.Monday]: 'Poniedziałek',
  [DayOfWeek.Tuesday]: 'Wtorek',
  [DayOfWeek.Wednesday]: 'Środa',
  [DayOfWeek.Thursday]: 'Czwartek',
  [DayOfWeek.Friday]: 'Piątek',
  [DayOfWeek.Saturday]: 'Sobota',
  [DayOfWeek.Sunday]: 'Niedziela',
};

export const POLISH_DAY_NAMES_SHORT: Record<DayOfWeek, string> = {
  [DayOfWeek.Monday]: 'Pon',
  [DayOfWeek.Tuesday]: 'Wt',
  [DayOfWeek.Wednesday]: 'Śr',
  [DayOfWeek.Thursday]: 'Czw',
  [DayOfWeek.Friday]: 'Pt',
  [DayOfWeek.Saturday]: 'Sob',
  [DayOfWeek.Sunday]: 'Nd',
};

export const DAYS_ORDER: DayOfWeek[] = [
  DayOfWeek.Monday,
  DayOfWeek.Tuesday,
  DayOfWeek.Wednesday,
  DayOfWeek.Thursday,
  DayOfWeek.Friday,
  DayOfWeek.Saturday,
  DayOfWeek.Sunday,
];
